'use client';

import Skeleton from '@/components/common/LoadingSkeleton/Skeleton';
import { PAGE_TITLES } from '@/constants/my-profile';
import { useAuthContext } from '@/contexts/auth';
import { usePathname } from 'next/navigation';
import { Suspense } from 'react';

export const PageTitle = () => {
	const pathname = usePathname();
	const { isGuest, isLoading } = useAuthContext();

	const getPageTitle = () => {
		const title = PAGE_TITLES[pathname as keyof typeof PAGE_TITLES];

		if (typeof title === 'object') {
			return !isGuest ? title.authenticated : title.unAuthenticated;
		}

		return title;
	};

	if (!getPageTitle() || isLoading) {
		return null;
	}

	return (
		<Suspense fallback={<Skeleton lines={1} />}>
			<div className="border border-t-0 border-l-0 border-r-0 border-grey-3 pt-7.5 pb-2.5 text-center text-xl font-bold text-secondary-black">
				{getPageTitle()}
			</div>
		</Suspense>
	);
};
